import { Injectable } from '@angular/core';
import { AppServerAPI } from '@sdbn/common';
import { Observable } from 'rxjs';
import { VisitIdentity, VisitOverviewResponse } from './personal-visit-list.model';


@Injectable({
  providedIn: 'root'
})
export class PersonalVisitListService {

  constructor(private appServerAPI: AppServerAPI) { }

  public getPersonalVisits(visitIdentity: VisitIdentity): Observable<VisitOverviewResponse> {
    const url = `/client/control/visitsoverview/personalvisits`;
    return this.appServerAPI.execute<VisitOverviewResponse>(url, visitIdentity);
  }
}
